/* Marcel Afters PDP viewer (12 Oct 2026): click or tap a gallery photograph to see every photograph whole, at full resolution. */
(function () {
  function build(track) {
    var figs = [].slice.call(track.querySelectorAll('.mx-pdp__slide:not([hidden]) img'));
    if (!figs.length) return null;
    var d = document.createElement('dialog');
    d.className = 'mx-zoom';
    d.setAttribute('aria-label', 'Product photographs');
    var html = '<button type="button" class="mx-zoom__x" aria-label="Close"><svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true"><path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="1.2"/></svg></button><p class="mx-zoom__n" aria-hidden="true"></p><div class="mx-zoom__scroll">';
    figs.forEach(function (im, i) {
      html += '<figure class="mx-zoom__f" data-i="' + i + '"><img alt="' + (im.alt || '').replace(/"/g, '&quot;') + '" srcset="' + im.srcset + '" sizes="100vw" src="' + im.currentSrc + '" decoding="async" loading="' + (i < 2 ? 'eager' : 'lazy') + '"></figure>';
    });
    d.innerHTML = html + '</div>';
    document.body.appendChild(d);
    var sc = d.querySelector('.mx-zoom__scroll'), n = d.querySelector('.mx-zoom__n'), tot = figs.length;
    function count() { var i = Math.round(sc.scrollTop / sc.clientHeight); n.textContent = (i + 1) + ' / ' + tot; }
    sc.addEventListener('scroll', count, { passive: true });
    d.querySelector('.mx-zoom__x').addEventListener('click', function () { d.close(); });
    d.addEventListener('click', function (e) { if (e.target.tagName !== 'IMG' && !e.target.closest('.mx-zoom__x')) d.close(); });
    d.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { sc.scrollBy({ top: sc.clientHeight }); e.preventDefault(); }
      if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { sc.scrollBy({ top: -sc.clientHeight }); e.preventDefault(); }
    });
    d._open = function (i) { d.showModal(); sc.scrollTop = i * sc.clientHeight; count(); };
    return d;
  }
  document.addEventListener('click', function (e) {
    var fig = e.target.closest('.mx-pdp__slide');
    if (!fig || e.defaultPrevented) return;
    var track = fig.closest('[data-mx-gal-track]');
    if (!track) return;
    // phone swipes are not clicks: only open when the track is not mid-scroll
    var vis = [].slice.call(track.querySelectorAll('.mx-pdp__slide:not([hidden])'));
    var i = vis.indexOf(fig);
    if (track._zoom) { track._zoom.remove(); }
    track._zoom = build(track);
    if (track._zoom) track._zoom._open(Math.max(0, i));
  });
})();
